import { Methods, RestClient } from 'o2o_layout/lib/common/rest';
import { BIGDATA_CONSTANT } from '../../../../common/constant';

const UpdateSugesstionSegment = (dto: any) => {
  let url =
    BIGDATA_CONSTANT.url.console +
    `mngmnt/orgs/config/segment-suggestion/${dto.orgId}/${dto.suggestionType}/update
`;
  var restClient = new RestClient(Methods.POST, url);
  return new Promise((resolve, reject) => {
    restClient.execute({}, { suggestDetail: dto.suggestDetail }).then(
      (response: any) => {
        const user: any = response.data;
        resolve(user);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export default UpdateSugesstionSegment;
